import { useTranslation } from 'react-i18next';

/**
 * Root-level crash fallback: a component threw above every route, so keep it
 * dependency-free (no router, no contexts) — only i18n, already initialized
 * at module load. Reloading is the only safe recovery at this level.
 */
const RootErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 px-6 text-center">
      <p className="text-lg text-gray-800">{t('An error occurred. Please try again later.')}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="px-5 py-2.5 rounded-lg bg-black text-white text-sm font-medium"
      >
        {t('Reload the page')}
      </button>
    </div>
  );
};

export { RootErrorFallback };
